<app-modal
  [title]="'Add note' | trans:'add-note-modal/header/title'"
  maxWidth="525px"
  (closed)="note = null"
>
  <ng-template>
    <div>
      <app-form-control [label]="'Note' | trans:'add-note-modal/form/note-label'" [isRequired]="true">
        <textarea
          [placeholder]="'Enter note' | trans:'add-note-modal/form/enter-note-placeholder'"
          [(ngModel)]="note"
          height="150px"
        ></textarea>
      </app-form-control>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-32">
      <button
        class="button button--md button--secondary text-uppercase flex-grow-1 w-0"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'add-note-modal/buttons/cancel' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase flex-grow-1 w-0"
        (click)="addNote()"
      >
        {{ 'Add note' | trans:'add-note-modal/buttons/add-note' }}
      </button>
    </div>
  </ng-container>
</app-modal>
